import React, { useEffect, useState } from 'react';
import { FaFileInvoiceDollar, FaSearch, FaCalendarAlt, FaUserTie } from 'react-icons/fa';
import './ReportesPago.css';
import { fetchAuth } from '../../utils/api';
import { supabase } from '../../supabaseClient';
 

function ReportesPago() {
  const [loading, setLoading] = useState(false);
  const [reporteGenerado, setReporteGenerado] = useState(false);
  const [colaboradorSeleccionado, setColaboradorSeleccionado] = useState('');
  const now = new Date();
  const [mesSeleccionado, setMesSeleccionado] = useState('');
  const [anioSeleccionado, setAnioSeleccionado] = useState(String(now.getFullYear()));
  const [datosReporte, setDatosReporte] = useState([]);
  const [totalGeneral, setTotalGeneral] = useState(0);
  const [busqueda, setBusqueda] = useState('');
  
  const [plantillaPDF, setPlantillaPDF] = useState(null);
  const [plantillaNombre, setPlantillaNombre] = useState('');


  const [colaboradores, setColaboradores] = useState([]);
  const [tarifaPorUsuario, setTarifaPorUsuario] = useState({});
  const [emailsPorUsuario, setEmailsPorUsuario] = useState({});
  const [toast, setToast] = useState({ visible: false, type: 'success', message: '' });
  const [envios, setEnvios] = useState({});
  const [enviosCorreo, setEnviosCorreo] = useState({});
  const [estadoSeleccionado, setEstadoSeleccionado] = useState('');
  const [historialPagos, setHistorialPagos] = useState([]);
  const [historialBusqueda, setHistorialBusqueda] = useState('');
  const [historialLoading, setHistorialLoading] = useState(false);
  const toDate = (s) => {
    if (!s) return null;
    const d = new Date(s);
    return isNaN(d.getTime()) ? null : d;
  };

  const daysBetween = (startStr, endStr) => {
    const a = toDate(startStr);
    const b = toDate(endStr);
    if (!a || !b) return null;
    const ms = b.getTime() - a.getTime();
    const diffDays = Math.floor(ms / 86400000);
    return Math.max(1, diffDays + 1);
  };

  const durationForTask = (t) => {
    const start = t.fecha_inicio || t.fecha_aprobada;
    const end = t.fecha_aprobada;
    const val = daysBetween(start, end);
    return val ?? 1;
  };

  const fechaLimiteInicial = (t) => {
    const v = t.fecha_entrega_inicial || t.fecha_termino_original || t.fecha_termino_inicial || t.fecha_termino || t.fecha_inicio || t.fecha_aprobada;
    if (v) {
      const d = toDate(v);
      if (d) return d.toISOString().split('T')[0];
      return String(v).split('T')[0].split(' ')[0];
    }
    const desc = String(t.descripcion || t.tarea?.descripcion || '').trim();
    const m = desc.match(/\[FECHA_LIMITE_INICIAL:([0-9]{4}-[0-9]{2}-[0-9]{2})\]/);
    if (m && m[1]) return m[1];
    return '';
  };

  const formatMonto = (val) => {
    if (val === null || val === undefined || val === '') return '-';
    const n = Number(val);
    if (isNaN(n)) return String(val);
    return `$\u00A0${n.toLocaleString('es-CL')}`;
  };
  const matchesSearch = (t) => {
    const s = String(busqueda || '').toLowerCase().trim();
    if (!s) return true;
    const fields = [t.nombre_tarea, t?.proyecto?.nombre_proyecto, t?.etapa?.nombre, t?.colaborador?.nombre];
    return fields.some(v => String(v || '').toLowerCase().includes(s));
  };
  const tareasTodas = datosReporte.flatMap(m => m.tareas || []);
  const tareasFiltradas = tareasTodas.filter(matchesSearch);
  const totalHoras = tareasFiltradas.reduce((acc, t) => acc + ((durationForTask(t) ?? 1) * 8), 0);
  const totalBrutoCalc = tareasFiltradas.reduce((acc, t) => {
    const monto = tarifaPorUsuario[t.colaborador?.id_usuario || t.id_usuario_asignado] ?? null;
    const dias = durationForTask(t) ?? 1;
    const total = monto != null ? dias * 8 * Number(monto) : 0;
    return acc + total;
  }, 0);
  const totalRetencionCalc = Math.round(totalBrutoCalc * 0.145);
  const totalLiquidoCalc = Math.max(0, totalBrutoCalc - totalRetencionCalc);
  const totalTareasAprobadas = tareasFiltradas.length;
  const montoPagadoCalc = 0;
  const montoPendienteCalc = totalLiquidoCalc;

  useEffect(() => {
    if (!estadoSeleccionado) return;
    const sel = colaboradores.find(c => c.id === colaboradorSeleccionado);
    if (!sel || (String(sel.estado || '').toUpperCase() !== String(estadoSeleccionado))) {
      setColaboradorSeleccionado('');
    }
  }, [estadoSeleccionado, colaboradores]);

  useEffect(() => {
    const toTitle = (s) => String(s || '').toLowerCase().split(' ').filter(Boolean).map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
    const fetchColaboradores = async () => {
      try {
        const data = await fetchAuth('/api/admin/usuarios/');
        const usuarios = data.usuarios || [];
        const cols = usuarios
          .filter(u => (u.rol_nombre || '').toUpperCase() === 'COLABORADOR')
          .map(u => ({ id: u.id_usuario, nombre: toTitle(u.nombre), estado: (u.estado || '').toUpperCase() }));
        setColaboradores(cols);
        const map = {};
        const emails = {};
        usuarios.forEach(u => {
          if ((u.rol_nombre || '').toUpperCase() === 'COLABORADOR') {
            const t = u.tarifa || {};
            map[u.id_usuario] = t.monto ?? null;
            emails[u.id_usuario] = u.email || null;
          }
        });
        setTarifaPorUsuario(map);
        setEmailsPorUsuario(emails);

        try {
          setHistorialLoading(true);
          const res = await fetchAuth('/api/admin/pagos/');
          const list = Array.isArray(res?.pagos) ? res.pagos : [];
          setHistorialPagos(list);
        } catch (err) {
          console.error('Error cargando historial de pagos:', err);
        } finally {
          setHistorialLoading(false);
        }
      } catch (err) {
        console.error('Error cargando colaboradores:', err);
      }
    };
    fetchColaboradores();
  }, []);

  const meses = [
    { value: '', label: 'Todos los meses' },
    { value: '01', label: 'Enero' },
    { value: '02', label: 'Febrero' },
    { value: '03', label: 'Marzo' },
    { value: '04', label: 'Abril' },
    { value: '05', label: 'Mayo' },
    { value: '06', label: 'Junio' },
    { value: '07', label: 'Julio' },
    { value: '08', label: 'Agosto' },
    { value: '09', label: 'Septiembre' },
    { value: '10', label: 'Octubre' },
    { value: '11', label: 'Noviembre' },
    { value: '12', label: 'Diciembre' },
  ];
  const mesesCatalog = meses.filter(m => m.value);

  const formatMonthYear = (m, y) => {
    const item = meses.find(mm => mm.value === m);
    if (!m) return 'Todos los meses';
    return item ? `${item.label} ${y}` : `${y}-${m}`;
  };

  function MonthDropdown({ value, onChange, options, disabled }) {
    const [open, setOpen] = useState(false);
    const sel = options.find(o => o.value === value);
    const label = value === '' ? 'Seleccionar mes' : (sel ? sel.label : 'Seleccionar mes');
    const toggle = () => { if (!disabled) setOpen(!open); };
    const select = (val) => { onChange(val); setOpen(false); };
    return (
      <div className="dropdown">
        <button type="button" className={`dropdown-button ${disabled ? 'disabled' : ''}`} onClick={toggle} disabled={disabled}>
          <span>{label}</span>
          <span className="dropdown-arrow" aria-hidden>▾</span>
        </button>
        {open && (
          <div className="dropdown-menu" role="listbox">
            {options.map(opt => (
              <div
                key={opt.value}
                role="option"
                aria-selected={opt.value === value}
                className={`dropdown-option ${opt.value === value ? 'selected' : ''}`}
                onClick={() => select(opt.value)}
              >
                {opt.label}
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }

  function YearDropdown({ value, onChange, options, disabled }) {
    const [open, setOpen] = useState(false);
    const sel = options.find(o => o.value === value);
    const label = sel ? sel.label : 'Seleccionar año';
    const toggle = () => { if (!disabled) setOpen(!open); };
    const select = (val) => { onChange(val); setOpen(false); };
    return (
      <div className="dropdown">
        <button type="button" className={`dropdown-button ${disabled ? 'disabled' : ''}`} onClick={toggle} disabled={disabled}>
          <span>{label}</span>
          <span className="dropdown-arrow" aria-hidden>▾</span>
        </button>
        {open && (
          <div className="dropdown-menu" role="listbox">
            {options.map(opt => (
              <div
                key={opt.value}
                role="option"
                aria-selected={opt.value === value}
                className={`dropdown-option ${opt.value === value ? 'selected' : ''}`}
                onClick={() => select(opt.value)}
              >
                {opt.label}
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }

  function ColaboradorDropdown({ value, onChange, options, disabled }) {
    const [open, setOpen] = useState(false);
    const sel = options.find(o => o.value === value);
    const label = sel ? sel.label : 'Seleccionar colaborador...';
    const toggle = () => { if (!disabled) setOpen(!open); };
    const select = (val) => { onChange(val); setOpen(false); };
    return (
      <div className="dropdown">
        <button type="button" className={`dropdown-button ${disabled ? 'disabled' : ''}`} onClick={toggle} disabled={disabled}>
          <span>{label}</span>
          <span className="dropdown-arrow" aria-hidden>▾</span>
        </button>
        {open && (
          <div className="dropdown-menu" role="listbox">
            {options.map(opt => (
              <div
                key={opt.value}
                role="option"
                aria-selected={opt.value === value}
                className={`dropdown-option ${opt.value === value ? 'selected' : ''}`}
                onClick={() => select(opt.value)}
              >
                {opt.label}
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }

  function EstadoDropdown({ value, onChange, options, disabled }) {
    const [open, setOpen] = useState(false);
    const sel = options.find(o => o.value === value);
    const label = value === '' ? 'Seleccionar estado colaborador' : (sel ? sel.label : 'Seleccionar estado colaborador');
    const toggle = () => { if (!disabled) setOpen(!open); };
    const select = (val) => { onChange(val); setOpen(false); };
    return (
      <div className="dropdown">
        <button type="button" className={`dropdown-button ${disabled ? 'disabled' : ''}`} onClick={toggle} disabled={disabled}>
          <span>{label}</span>
          <span className="dropdown-arrow" aria-hidden>▾</span>
        </button>
        {open && (
          <div className="dropdown-menu" role="listbox">
            {options.map(opt => (
              <div
                key={opt.value}
                role="option"
                aria-selected={opt.value === value}
                className={`dropdown-option ${opt.value === value ? 'selected' : ''}`}
                onClick={() => select(opt.value)}
              >
                {opt.label}
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }


  const handleGenerarReporte = async () => {
    try {
      setLoading(true);
      const noMes = !mesSeleccionado;
      const noCol = !colaboradorSeleccionado || colaboradorSeleccionado === 'todos';
      const noEstado = !estadoSeleccionado;
      if (noMes && noCol && noEstado) {
        setDatosReporte([]);
        setTotalGeneral(0);
        setReporteGenerado(false);
        setLoading(false);
        return;
      }
      const params = new URLSearchParams();
      const y = parseInt(anioSeleccionado, 10);
      const m = mesSeleccionado ? parseInt(mesSeleccionado, 10) : null;
      if (m) {
        const first = new Date(y, m - 1, 1);
        const last = new Date(y, m, 0);
        const desde = first.toISOString().split('T')[0];
        const hasta = last.toISOString().split('T')[0];
        params.set('fecha_desde', desde);
        params.set('fecha_hasta', hasta);
      }
      params.set('id_colaborador', colaboradorSeleccionado || 'todos');
      if (estadoSeleccionado) params.set('estado_colaborador', estadoSeleccionado);
      const data = await fetchAuth(`/api/admin/reportes/tareas-aprobadas-mensual/?${params.toString()}`);
      const meses = (data.meses || []).slice().sort((a, b) => {
        const ma = mesesCatalog.find(mm => mm.label === a.nombre_mes)?.value || '01';
        const mb = mesesCatalog.find(mm => mm.label === b.nombre_mes)?.value || '01';
        const ya = parseInt(a.anio || anioSeleccionado, 10) || 0;
        const yb = parseInt(b.anio || anioSeleccionado, 10) || 0;
        if (ya !== yb) return yb - ya;
        return parseInt(mb, 10) - parseInt(ma, 10);
      });
      const total = meses.reduce((acc, m) => acc + (m.total_mes || 0), 0);
      setDatosReporte(meses);
      setTotalGeneral(total);
      setReporteGenerado(true);

      
      
    } catch (err) {
      alert(err.message || 'Error al generar el reporte');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => {
      if (data?.session) {
        setReporteGenerado(false);
      }
    });
  }, []);

  useEffect(() => {
    const loadTpl = async () => {
      try {
        const { data: session } = await supabase.auth.getSession();
        const token = session?.session?.access_token;
        const resp = await fetchAuth('/api/admin/plantillas/admin/', { rawResponse: true });
        if (resp.ok) {
          const meta = await resp.json();
          if (meta && meta.url) {
            try {
              const r = await fetchAuth(meta.url, { rawResponse: true });
              const b = await r.blob();
              if (String(b.type || '').toLowerCase().includes('pdf')) {
                setPlantillaPDF(b);
                setPlantillaNombre(String(meta.name || ''));
                return;
              }
            } catch {}
          }
        }
        try {
          const resp2 = await fetchAuth('/api/admin/plantillas/general/', { rawResponse: true });
          if (resp2.ok) {
            const meta2 = await resp2.json();
            if (meta2 && meta2.url) {
              try {
                const r2 = await fetchAuth(meta2.url, { rawResponse: true });
                const b2 = await r2.blob();
                if (String(b2.type || '').toLowerCase().includes('pdf')) {
                  setPlantillaPDF(b2);
                  setPlantillaNombre(String(meta2.name || ''));
                  return;
                }
              } catch {}
            }
          }
        } catch {}
        const primary = localStorage.getItem('config_plantillas_reportes_general');
        const fallback = localStorage.getItem('reportes_pago_plantilla_pdf');
        const saved = primary || fallback;
        if (saved) {
          try {
            const m = JSON.parse(saved);
            if (m && m.dataUrl) {
              const durl = String(m.dataUrl || '');
              const okMime = durl.toLowerCase().includes('application/pdf');
              fetch(durl).then(async r => {
                const b = await r.blob();
                if (okMime || String(b.type || '').toLowerCase().includes('pdf')) {
                  setPlantillaPDF(b);
                  setPlantillaNombre(String(m.name || ''));
                }
              }).catch(() => {});
            }
          } catch {}
        }
      } catch {}
    };
    loadTpl();
  }, []);

  const handleExportarPDF = () => {
    const run = async () => {
      const { jsPDF } = await import('jspdf');
      const autoTable = (await import('jspdf-autotable')).default;
      const { PDFDocument } = await import('pdf-lib');
      const doc = new jsPDF({ unit: 'pt', format: 'a4' });
      doc.setFontSize(16);
      doc.text('Reporte de Pago', 40, 40);
      doc.setFontSize(11);
      doc.text(`Período: ${formatMonthYear(mesSeleccionado, anioSeleccionado)}`, 40, 60);

      const head = [[
        'Colaborador','Tarea','Proyecto','Etapa','Fecha Límite','Fecha Aprobada','Duración (días)','Horas diarias estimadas','Total a pagar'
      ]];
      const body = [];
      let totalBruto = 0;
      datosReporte.forEach(m => {
        (m.tareas || []).forEach(t => {
          const dur = durationForTask(t);
          const monto = tarifaPorUsuario[t.colaborador?.id_usuario || t.id_usuario_asignado] ?? null;
          const total = monto != null ? dur * 8 * Number(monto) : null;
          if (total != null) totalBruto += total;
          body.push([
            String(t.colaborador?.nombre || ''),
            String(t.nombre_tarea || ''),
            String(t.proyecto?.nombre_proyecto || ''),
            String(t.etapa?.nombre || ''),
            String(fechaLimiteInicial(t) || ''),
            String(t.fecha_aprobada || ''),
            dur ?? '',
            '8 Hrs.',
            total != null ? formatMonto(total) : '-'
          ]);
        });
      });

      const retencion = Math.round(totalBruto * 0.145);
      const liquido = Math.max(0, totalBruto - retencion);
      const foot = [
        [
          { content: 'Monto bruto:', styles: { halign: 'right' }, colSpan: 7 },
          { content: formatMonto(totalBruto), styles: { halign: 'right', textColor: [139, 92, 246], fontStyle: 'bold' } }
        ],
        [
          { content: 'Retención 14.5%:', styles: { halign: 'right' }, colSpan: 7 },
          { content: formatMonto(retencion), styles: { halign: 'right', textColor: [245, 158, 11], fontStyle: 'bold' } }
        ],
        [
          { content: 'Monto líquido pagar BH:', styles: { halign: 'right' }, colSpan: 7 },
          { content: formatMonto(liquido), styles: { halign: 'right', textColor: [16, 185, 129], fontStyle: 'bold' } }
        ]
      ];

      autoTable(doc, {
        head,
        body,
        startY: plantillaPDF ? 120 : 70,
        styles: {
          fontSize: 8,
          cellPadding: 5,
          lineColor: [226, 232, 240],
          lineWidth: 0.5,
          textColor: [15, 23, 42],
          overflow: 'linebreak'
        },
        headStyles: {
          fillColor: [99, 102, 241],
          textColor: 255,
          fontStyle: 'bold'
        },
        alternateRowStyles: { fillColor: [248, 250, 252] },
        columnStyles: {
          0: { cellWidth: 60 },
          1: { cellWidth: 75 },
          2: { cellWidth: 80 },
          3: { cellWidth: 50 },
          4: { cellWidth: 65 },
          5: { cellWidth: 65 },
          6: { cellWidth: 45, halign: 'center' },
          7: { cellWidth: 65, halign: 'center' },
          8: { cellWidth: 65, halign: 'right' }
        },
        margin: { left: 30, right: 30 },
        theme: 'grid',
        foot,
        footStyles: {
          fillColor: [248, 250, 252],
          textColor: [15, 23, 42],
          lineColor: [226, 232, 240],
          lineWidth: 0.5
        },
        showFoot: 'lastPage'
      });
      const fname = `reporte_tareas_aprobadas_${new Date().toISOString().split('T')[0]}.pdf`;
      if (plantillaPDF) {
        try {
          const contentArrayBuffer = doc.output('arraybuffer');
          const tplArrayBuffer = await plantillaPDF.arrayBuffer();
          const tplDoc = await PDFDocument.load(tplArrayBuffer);
          const contentDoc = await PDFDocument.load(contentArrayBuffer);
          const [embeddedFirst] = await tplDoc.embedPdf(contentArrayBuffer);
          const tplPages = tplDoc.getPages();
          if (tplPages.length > 0) {
            const firstTplPage = tplPages[0];
            const { width, height } = firstTplPage.getSize();
            firstTplPage.drawPage(embeddedFirst, { x: 0, y: 0, width, height });
          }
          const indices = contentDoc.getPageIndices();
          if (indices.length > 1) {
            const rest = await tplDoc.copyPages(contentDoc, indices.slice(1));
            rest.forEach(p => tplDoc.addPage(p));
          }
          const mergedBytes = await tplDoc.save();
          const mergedBlob = new Blob([mergedBytes], { type: 'application/pdf' });
          const mergedUrl = URL.createObjectURL(mergedBlob);
          const a = document.createElement('a');
          a.href = mergedUrl;
          a.download = fname;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          setTimeout(() => URL.revokeObjectURL(mergedUrl), 2000);
        } catch (err) {
          const blob = doc.output('blob');
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = fname;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          setTimeout(() => URL.revokeObjectURL(url), 2000);
        }
      } else {
        const blob = doc.output('blob');
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fname;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        setTimeout(() => URL.revokeObjectURL(url), 2000);
      }
    };
    run();
  };

  const handleExportarExcel = () => {
    const tareas = datosReporte.flatMap(m => m.tareas || []).filter(matchesSearch);
    const head = ['Colaborador','Tarea','Proyecto','Etapa','Fecha Límite','Fecha Aprobada','Duración (días)','Horas diarias estimadas','Tarifa','Total a pagar'];
    const rows = tareas.map(t => {
      const dur = durationForTask(t) ?? 1;
      const horas = dur * 8;
      const monto = tarifaPorUsuario[t.colaborador?.id_usuario || t.id_usuario_asignado] ?? null;
      const total = monto != null ? horas * Number(monto) : null;
      const vals = [
        String(t.colaborador?.nombre || ''),
        String(t.nombre_tarea || ''),
        String(t.proyecto?.nombre_proyecto || ''),
        String(t.etapa?.nombre || ''),
        String(fechaLimiteInicial(t) || ''),
        String(t.fecha_aprobada || ''),
        String(dur),
        '8 Hrs.',
        monto != null ? String(monto) : '',
        total != null ? String(total) : ''
      ];
      return vals.map(v => `"${String(v).replace(/"/g, '""')}"`).join(',');
    });
    const csv = [head.join(','), ...rows].join('\n');
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `reporte_tareas_aprobadas_${new Date().toISOString().split('T')[0]}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(() => URL.revokeObjectURL(url), 2000);
  };

  const handleEnviarPDFCorreo = () => {
    const run = async () => {
      const { jsPDF } = await import('jspdf');
      const autoTable = (await import('jspdf-autotable')).default;
      const { PDFDocument } = await import('pdf-lib');
      const doc = new jsPDF({ unit: 'pt', format: 'a4' });
      doc.setFontSize(16);
      doc.text('Reporte de Pago', 40, 40);
      doc.setFontSize(11);
      doc.text(`Período: ${formatMonthYear(mesSeleccionado, anioSeleccionado)}`, 40, 60);
      const head = [[
        'Colaborador','Tarea','Proyecto','Etapa','Fecha Límite','Fecha Aprobada','Duración (días)','Horas diarias estimadas','Total a pagar'
      ]];
      const tableBody = [];
      let totalBruto = 0;
      datosReporte.forEach(m => {
        (m.tareas || []).forEach(t => {
          const dur = durationForTask(t);
          const monto = tarifaPorUsuario[t.colaborador?.id_usuario || t.id_usuario_asignado] ?? null;
          const total = monto != null ? dur * 8 * Number(monto) : null;
          if (total != null) totalBruto += total;
          tableBody.push([
            String(t.colaborador?.nombre || ''),
            String(t.nombre_tarea || ''),
            String(t.proyecto?.nombre_proyecto || ''),
            String(t.etapa?.nombre || ''),
            String(fechaLimiteInicial(t) || ''),
            String(t.fecha_aprobada || ''),
            dur ?? '',
            '8 Hrs.',
            total != null ? formatMonto(total) : '-'
          ]);
        });
      });
      const retencion = Math.round(totalBruto * 0.145);
      const liquido = Math.max(0, totalBruto - retencion);
      const foot = [
        [ { content: 'Monto bruto:', styles: { halign: 'right' }, colSpan: 7 }, { content: formatMonto(totalBruto), styles: { halign: 'right', textColor: [139, 92, 246], fontStyle: 'bold' } } ],
        [ { content: 'Retención 14.5%:', styles: { halign: 'right' }, colSpan: 7 }, { content: formatMonto(retencion), styles: { halign: 'right', textColor: [245, 158, 11], fontStyle: 'bold' } } ],
        [ { content: 'Monto líquido pagar BH:', styles: { halign: 'right' }, colSpan: 7 }, { content: formatMonto(liquido), styles: { halign: 'right', textColor: [16, 185, 129], fontStyle: 'bold' } } ]
      ];
      autoTable(doc, { head, body: tableBody, startY: plantillaPDF ? 120 : 70, styles: { fontSize: 8, cellPadding: 5, lineColor: [226,232,240], lineWidth: 0.5, textColor: [15,23,42], overflow: 'linebreak' }, headStyles: { fillColor: [99,102,241], textColor: 255, fontStyle: 'bold' }, alternateRowStyles: { fillColor: [248,250,252] }, columnStyles: { 0:{cellWidth:60},1:{cellWidth:75},2:{cellWidth:85},3:{cellWidth:50},4:{cellWidth:70},5:{cellWidth:50,halign:'center'},6:{cellWidth:65,halign:'center'},7:{cellWidth:65,halign:'right'} }, margin:{ left:30, right:30 }, theme:'grid', foot, footStyles:{ fillColor:[248,250,252], textColor:[15,23,42], lineColor:[226,232,240], lineWidth:0.5 }, showFoot:'lastPage' });
      const fname = `reporte_tareas_aprobadas_${new Date().toISOString().split('T')[0]}.pdf`;
      let blob;
      if (plantillaPDF) {
        try {
          const contentArrayBuffer = doc.output('arraybuffer');
          const tplArrayBuffer = await plantillaPDF.arrayBuffer();
          const { PDFDocument } = await import('pdf-lib');
          const tplDoc = await PDFDocument.load(tplArrayBuffer);
          const contentDoc = await PDFDocument.load(contentArrayBuffer);
          const [embeddedFirst] = await tplDoc.embedPdf(contentArrayBuffer);
          const tplPages = tplDoc.getPages();
          if (tplPages.length > 0) {
            const firstTplPage = tplPages[0];
            const { width, height } = firstTplPage.getSize();
            firstTplPage.drawPage(embeddedFirst, { x: 0, y: 0, width, height });
          }
          const indices = contentDoc.getPageIndices();
          if (indices.length > 1) {
            const rest = await tplDoc.copyPages(contentDoc, indices.slice(1));
            rest.forEach(p => tplDoc.addPage(p));
          }
          const mergedBytes = await tplDoc.save();
          blob = new Blob([mergedBytes], { type: 'application/pdf' });
        } catch (err) {
          blob = doc.output('blob');
        }
      } else {
        blob = doc.output('blob');
      }
      const dataUrl = await new Promise(res => { const r = new FileReader(); r.onload = () => res(r.result); r.readAsDataURL(blob); });
      const pdf_base64 = String(dataUrl).split(',')[1] || '';
      const ids = new Set();
      datosReporte.forEach(m => (m.tareas || []).forEach(t => { const idu = t.colaborador?.id_usuario || t.id_usuario_asignado; if (idu) ids.add(String(idu)); }));
      const emails = Array.from(ids).map(id => emailsPorUsuario[id]).filter(Boolean);
      if (!emails.length) {
        setToast({ visible: true, type: 'error', message: 'No hay correos de colaboradores en el reporte' });
        setTimeout(() => setToast(t => ({ ...t, visible: false })), 3000);
        return;
      }
      const subject = `CommitFlow - Reporte de Pago - ${formatMonthYear(mesSeleccionado, anioSeleccionado)}`;
      const emailBody = 'Adjuntamos su reporte de pago del período seleccionado.';
      await fetchAuth('/api/admin/reportes/enviar-pdf/', { method: 'POST', body: JSON.stringify({ emails, subject, body: emailBody, pdf_name: fname, pdf_base64 }) });
      setEnviosCorreo(prev => ({ ...prev, global: true }));
      setToast({ visible: true, type: 'success', message: 'Reporte enviado por correo' });
      setTimeout(() => setToast(t => ({ ...t, visible: false })), 3000);
    };
    run();
  };

  const handleExportarPDFMes = (mes) => {
    const run = async () => {
      const { jsPDF } = await import('jspdf');
      const autoTable = (await import('jspdf-autotable')).default;
      const { PDFDocument } = await import('pdf-lib');
      const doc = new jsPDF({ unit: 'pt', format: 'a4' });
      doc.setFontSize(16);
      doc.text('Reporte de Pago', 40, 40);
      doc.setFontSize(11);
      doc.text(`Período: ${mes.nombre_mes} ${mes.anio}`, 40, 60);

      const head = [[
        'Colaborador','Tarea','Proyecto','Etapa','Fecha Aprobada','Duración (días)','Horas diarias estimadas','Total a pagar'
      ]];
      const body = [];
      let totalBruto = 0;
      (mes.tareas || []).forEach(t => {
        const dur = durationForTask(t);
        const monto = tarifaPorUsuario[t.colaborador?.id_usuario || t.id_usuario_asignado] ?? null;
        const total = monto != null ? dur * 8 * Number(monto) : null;
        if (total != null) totalBruto += total;
        body.push([
          String(t.colaborador?.nombre || ''),
          String(t.nombre_tarea || ''),
          String(t.proyecto?.nombre_proyecto || ''),
          String(t.etapa?.nombre || ''),
          String(t.fecha_aprobada || ''),
          dur ?? '',
          '8 Hrs.',
          total != null ? formatMonto(total) : '-'
        ]);
      });

      const retencion = Math.round(totalBruto * 0.145);
      const liquido = Math.max(0, totalBruto - retencion);
      const foot = [
        [
          { content: 'Monto bruto:', styles: { halign: 'right' }, colSpan: 7 },
          { content: formatMonto(totalBruto), styles: { halign: 'right', textColor: [139, 92, 246], fontStyle: 'bold' } }
        ],
        [
          { content: 'Retención 14.5%:', styles: { halign: 'right' }, colSpan: 7 },
          { content: formatMonto(retencion), styles: { halign: 'right', textColor: [245, 158, 11], fontStyle: 'bold' } }
        ],
        [
          { content: 'Monto líquido pagar BH:', styles: { halign: 'right' }, colSpan: 7 },
          { content: formatMonto(liquido), styles: { halign: 'right', textColor: [16, 185, 129], fontStyle: 'bold' } }
        ]
      ];

      autoTable(doc, {
        head,
        body,
        startY: plantillaPDF ? 120 : 70,
        styles: {
          fontSize: 8,
          cellPadding: 5,
          lineColor: [226, 232, 240],
          lineWidth: 0.5,
          textColor: [15, 23, 42],
          overflow: 'linebreak'
        },
        headStyles: {
          fillColor: [99, 102, 241],
          textColor: 255,
          fontStyle: 'bold'
        },
        alternateRowStyles: { fillColor: [248, 250, 252] },
        columnStyles: {
          0: { cellWidth: 60 },
          1: { cellWidth: 75 },
          2: { cellWidth: 85 },
          3: { cellWidth: 50 },
          4: { cellWidth: 70 },
          5: { cellWidth: 50, halign: 'center' },
          6: { cellWidth: 65, halign: 'center' },
          7: { cellWidth: 65, halign: 'right' }
        },
        margin: { left: 30, right: 30 },
        theme: 'grid',
        foot,
        footStyles: {
          fillColor: [248, 250, 252],
          textColor: [15, 23, 42],
          lineColor: [226, 232, 240],
          lineWidth: 0.5
        },
        showFoot: 'lastPage'
      });
      const fname = `reporte_tareas_aprobadas_${mes.anio}-${(mesesCatalog.find(mm => mm.label === mes.nombre_mes)?.value || '01')}.pdf`;
      if (plantillaPDF) {
        try {
          const contentArrayBuffer = doc.output('arraybuffer');
          const tplArrayBuffer = await plantillaPDF.arrayBuffer();
          const tplDoc = await PDFDocument.load(tplArrayBuffer);
          const contentDoc = await PDFDocument.load(contentArrayBuffer);
          const [embeddedFirst] = await tplDoc.embedPdf(contentArrayBuffer);
          const tplPages = tplDoc.getPages();
          if (tplPages.length > 0) {
            const firstTplPage = tplPages[0];
            const { width, height } = firstTplPage.getSize();
            firstTplPage.drawPage(embeddedFirst, { x: 0, y: 0, width, height });
          }
          const indices = contentDoc.getPageIndices();
          if (indices.length > 1) {
            const rest = await tplDoc.copyPages(contentDoc, indices.slice(1));
            rest.forEach(p => tplDoc.addPage(p));
          }
          const mergedBytes = await tplDoc.save();
          const mergedBlob = new Blob([mergedBytes], { type: 'application/pdf' });
          const mergedUrl = URL.createObjectURL(mergedBlob);
          const a = document.createElement('a');
          a.href = mergedUrl;
          a.download = fname;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          setTimeout(() => URL.revokeObjectURL(mergedUrl), 2000);
        } catch (err) {
          const blob = doc.output('blob');
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = fname;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          setTimeout(() => URL.revokeObjectURL(url), 2000);
        }
      } else {
        const blob = doc.output('blob');
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fname;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        setTimeout(() => URL.revokeObjectURL(url), 2000);
      }
    };
    run();
  };

  const handleEnviarPDFCorreoMes = (mes) => {
    const run = async () => {
      const { jsPDF } = await import('jspdf');
      const autoTable = (await import('jspdf-autotable')).default;
      const { PDFDocument } = await import('pdf-lib');
      const doc = new jsPDF({ unit: 'pt', format: 'a4' });
      doc.setFontSize(16);
      doc.text('Reporte de Pago', 40, 40);
      doc.setFontSize(11);
      doc.text(`Período: ${mes.nombre_mes} ${mes.anio}`, 40, 60);
      const head = [[
        'Colaborador','Tarea','Proyecto','Etapa','Fecha Aprobada','Duración (días)','Horas diarias estimadas','Total a pagar'
      ]];
      const tableBody = [];
      let totalBruto = 0;
      (mes.tareas || []).forEach(t => {
        const dur = durationForTask(t);
        const monto = tarifaPorUsuario[t.colaborador?.id_usuario || t.id_usuario_asignado] ?? null;
        const total = monto != null ? dur * 8 * Number(monto) : null;
        if (total != null) totalBruto += total;
        tableBody.push([
          String(t.colaborador?.nombre || ''),
          String(t.nombre_tarea || ''),
          String(t.proyecto?.nombre_proyecto || ''),
          String(t.etapa?.nombre || ''),
          String(t.fecha_aprobada || ''),
          dur ?? '',
          '8 Hrs.',
          total != null ? formatMonto(total) : '-'
        ]);
      });
      const retencion = Math.round(totalBruto * 0.145);
      const liquido = Math.max(0, totalBruto - retencion);
      const foot = [
        [ { content: 'Monto bruto:', styles: { halign: 'right' }, colSpan: 7 }, { content: formatMonto(totalBruto), styles: { halign: 'right', textColor: [139, 92, 246], fontStyle: 'bold' } } ],
        [ { content: 'Retención 14.5%:', styles: { halign: 'right' }, colSpan: 7 }, { content: formatMonto(retencion), styles: { halign: 'right', textColor: [245, 158, 11], fontStyle: 'bold' } } ],
        [ { content: 'Monto líquido pagar BH:', styles: { halign: 'right' }, colSpan: 7 }, { content: formatMonto(liquido), styles: { halign: 'right', textColor: [16, 185, 129], fontStyle: 'bold' } } ]
      ];
      autoTable(doc, { head, body: tableBody, startY: plantillaPDF ? 120 : 70, styles: { fontSize: 8, cellPadding: 5, lineColor: [226,232,240], lineWidth: 0.5, textColor: [15,23,42], overflow: 'linebreak' }, headStyles: { fillColor: [99,102,241], textColor: 255, fontStyle: 'bold' }, alternateRowStyles: { fillColor: [248,250,252] }, columnStyles: { 0:{cellWidth:60},1:{cellWidth:75},2:{cellWidth:85},3:{cellWidth:50},4:{cellWidth:70},5:{cellWidth:50,halign:'center'},6:{cellWidth:65,halign:'center'},7:{cellWidth:65,halign:'right'} }, margin:{ left:30, right:30 }, theme:'grid', foot, footStyles:{ fillColor:[248,250,252], textColor:[15,23,42], lineColor:[226,232,240], lineWidth:0.5 }, showFoot:'lastPage' });
      const fname = `reporte_tareas_aprobadas_${mes.anio}-${(mesesCatalog.find(mm => mm.label === mes.nombre_mes)?.value || '01')}.pdf`;
      let blob;
      if (plantillaPDF) {
        try {
          const contentArrayBuffer = doc.output('arraybuffer');
          const tplArrayBuffer = await plantillaPDF.arrayBuffer();
          const { PDFDocument } = await import('pdf-lib');
          const tplDoc = await PDFDocument.load(tplArrayBuffer);
          const contentDoc = await PDFDocument.load(contentArrayBuffer);
          const [embeddedFirst] = await tplDoc.embedPdf(contentArrayBuffer);
          const tplPages = tplDoc.getPages();
          if (tplPages.length > 0) {
            const firstTplPage = tplPages[0];
            const { width, height } = firstTplPage.getSize();
            firstTplPage.drawPage(embeddedFirst, { x: 0, y: 0, width, height });
          }
          const indices = contentDoc.getPageIndices();
          if (indices.length > 1) {
            const rest = await tplDoc.copyPages(contentDoc, indices.slice(1));
            rest.forEach(p => tplDoc.addPage(p));
          }
          const mergedBytes = await tplDoc.save();
          blob = new Blob([mergedBytes], { type: 'application/pdf' });
        } catch (err) {
          blob = doc.output('blob');
        }
      } else {
        blob = doc.output('blob');
      }
      const dataUrl = await new Promise(res => { const r = new FileReader(); r.onload = () => res(r.result); r.readAsDataURL(blob); });
      const pdf_base64 = String(dataUrl).split(',')[1] || '';
      const ids = new Set();
      (mes.tareas || []).forEach(t => { const idu = t.colaborador?.id_usuario || t.id_usuario_asignado; if (idu) ids.add(String(idu)); });
      const emails = Array.from(ids).map(id => emailsPorUsuario[id]).filter(Boolean);
      if (!emails.length) {
        setToast({ visible: true, type: 'error', message: 'No hay correos de colaboradores en este mes' });
        setTimeout(() => setToast(t => ({ ...t, visible: false })), 3000);
        return;
      }
      const subject = `CommitFlow - Reporte de Pago - ${mes.nombre_mes} ${mes.anio}`;
      const emailBody = 'Adjuntamos su reporte de pago del período seleccionado.';
      await fetchAuth('/api/admin/reportes/enviar-pdf/', { method: 'POST', body: JSON.stringify({ emails, subject, body: emailBody, pdf_name: fname, pdf_base64 }) });
      const key = `${mes.anio}-${mesesCatalog.find(mm => mm.label === mes.nombre_mes)?.value || String(mes.mes || '').padStart(2,'0') || '01'}`;
      setEnviosCorreo(prev => ({ ...prev, [key]: true }));
      setToast({ visible: true, type: 'success', message: 'Reporte del mes enviado por correo' });
      setTimeout(() => setToast(t => ({ ...t, visible: false })), 3000);
    };
    run();
  };

  const handleEnviarMesColaborador = async (mes) => {
    try {
      const grupos = {};
      (mes.tareas || []).forEach(t => {
        const idu = t.colaborador?.id_usuario;
        if (!idu) return;
        const monto = tarifaPorUsuario[idu] ?? 0;
        const dias = durationForTask(t) ?? 1;
        const total = dias * 8 * Number(monto || 0);
        grupos[idu] = (grupos[idu] || 0) + total;
      });
      const pagos = Object.entries(grupos).map(([id_usuario, bruto]) => {
        const ret = Math.round(bruto * 0.145);
        const liq = Math.max(0, bruto - ret);
        const mm = mesesCatalog.find(mm => mm.label === mes.nombre_mes)?.value || String(mes.mes || '').padStart(2,'0') || '01';
        return {
          id_usuario: Number(id_usuario),
          anio: mes.anio,
          mes: String(mm).padStart(2, '0'),
          monto_bruto: Math.round(bruto),
          retencion: ret,
          monto_liquido: liq
        };
      });
      if (!pagos.length) {
        setToast({ visible: true, type: 'error', message: 'No hay colaboradores con tareas para enviar en este mes' });
        setTimeout(() => setToast(t => ({ ...t, visible: false })), 3000);
        return;
      }
      await fetchAuth('/api/admin/pagos/enviar/', { method: 'POST', body: JSON.stringify({ pagos }) });
      const key = `${mes.anio}-${mesesCatalog.find(mm => mm.label === mes.nombre_mes)?.value || String(mes.mes || '').padStart(2,'0') || '01'}`;
      setEnvios(prev => ({ ...prev, [key]: true }));
      setToast({ visible: true, type: 'success', message: 'Pagos enviados a colaboradores' });
      setTimeout(() => setToast(t => ({ ...t, visible: false })), 3000);
    } catch (err) {
      setToast({ visible: true, type: 'error', message: err.message || 'Error al enviar pagos' });
      setTimeout(() => setToast(t => ({ ...t, visible: false })), 3000);
    }
  };

  const handleLimpiar = () => {
    setReporteGenerado(false);
    setDatosReporte([]);
    setTotalGeneral(0);
    setColaboradorSeleccionado('');
    setMesSeleccionado('');
    setAnioSeleccionado(String(now.getFullYear()));
  };

  const handleExportarComprobanteHistorial = async (pago) => {
    try {
      const { jsPDF } = await import('jspdf');
      const autoTable = (await import('jspdf-autotable')).default;
      const doc = new jsPDF({ unit: 'pt', format: 'a4' });
      
      const colNombre = typeof pago.colaborador === 'object' ? (pago.colaborador.nombre || 'Colaborador') : (pago.colaborador || 'Colaborador');
      const bruto = Number(pago.monto || pago.monto_bruto || 0);
      const retencion = Math.round(bruto * 0.145);
      const liquido = Math.max(0, bruto - retencion);

      doc.setFillColor(15, 23, 42);
      doc.rect(0, 0, 595.28, 60, 'F');
      
      doc.setTextColor(255, 255, 255);
      doc.setFontSize(16);
      doc.setFont('helvetica', 'bold');
      doc.text('COMMITFLOW — COMPROBANTE DE PAGO', 40, 38);

      doc.setTextColor(15, 23, 42);
      doc.setFontSize(11);
      doc.setFont('helvetica', 'bold');
      doc.text('DETALLE DE LA LIQUIDACIÓN', 40, 90);

      doc.setFont('helvetica', 'normal');
      doc.setFontSize(10);
      doc.text(`N° Comprobante: #PAGO-00${pago.id || pago.id_pago || '1'}`, 40, 110);
      doc.text(`Colaborador: ${colNombre}`, 40, 125);
      doc.text(`Proyecto: ${pago.proyecto || 'General'}`, 40, 140);
      doc.text(`Período: ${pago.periodo || 'Febrero 2026'}`, 40, 155);
      doc.text(`Estado: ${pago.estado || 'PAGADO'}`, 40, 170);

      autoTable(doc, {
        startY: 190,
        head: [['Concepto / Descripción', 'Base de Cálculo', 'Monto (CLP)']],
        body: [
          ['Horas Acumuladas Trabajadas', `${pago.horas || 40} horas`, '-'],
          ['Monto Bruto Honorarios', 'Total calculado', formatMonto(bruto)],
          ['Retención Legal (14.5%)', 'Descuento legal impuesto', `- ${formatMonto(retencion)}`],
          ['Monto Líquido a Transferir', 'Neto resultatorio a pagar', formatMonto(liquido)]
        ],
        headStyles: { fillColor: [99, 102, 241], textColor: 255, fontStyle: 'bold' },
        styles: { fontSize: 9, cellPadding: 8 }
      });

      doc.save(`Comprobante_Pago_${colNombre.replace(/\s+/g, '_')}_${pago.periodo || '2026'}.pdf`);
      setToast({ visible: true, type: 'success', message: 'Comprobante PDF descargado exitosamente' });
      setTimeout(() => setToast(t => ({ ...t, visible: false })), 3000);
    } catch (err) {
      alert('Error al generar comprobante: ' + err.message);
    }
  };

  const handleMarcarPagadoHistorial = async (idPago) => {
    try {
      await fetchAuth('/api/admin/pagos/marcar-pagado/', { method: 'POST', body: JSON.stringify({ id_pago: idPago }) });
      setHistorialPagos(prev => prev.map(p => (p.id === idPago || p.id_pago === idPago) ? { ...p, estado: 'PAGADO' } : p));
      setToast({ visible: true, type: 'success', message: 'Pago marcado como realizado' });
      setTimeout(() => setToast(t => ({ ...t, visible: false })), 3000);
    } catch (err) {
      setToast({ visible: true, type: 'error', message: err.message || 'Error al actualizar pago' });
      setTimeout(() => setToast(t => ({ ...t, visible: false })), 3000);
    }
  };

  return (
    <div className="reportes-pago">
      {toast.visible && (
        <div className={`toast ${toast.type}`}>
          {toast.message}
        </div>
      )}
      <div className="reportes-header">
        <div className="reportes-title-section" style={{ justifyContent: 'space-between', width: '100%' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            <FaFileInvoiceDollar className="reportes-main-icon" />
            <div>
              <h1>Reporte de Pago</h1>
              <p className="reportes-subtitle">Consolida tareas aprobadas por colaborador en un período</p>
            </div>
          </div>
          {reporteGenerado && (
            <div style={{ textAlign: 'right' }}>
              {(() => {
                const col = colaboradores.find(c => String(c.id) === String(colaboradorSeleccionado));
                const colNombre = col ? col.nombre : 'Todos';
                const periodo = formatMonthYear(mesSeleccionado, anioSeleccionado);
                return (
                  <span style={{ color: '#64748b', fontWeight: 600 }}>
                    Mes: {periodo} – Colaborador: {colNombre}
                  </span>
                );
              })()}
            </div>
          )}
        </div>
      </div>

      {/* Filtros */}
      <div className="filtros-section">
        <h2>Filtros de Búsqueda</h2>
        <div className="filtros-grid">
          <div className="filtro-item">
            <label>
              <FaCalendarAlt /> Mes
            </label>
            <MonthDropdown
              value={mesSeleccionado}
              onChange={setMesSeleccionado}
              options={meses}
              disabled={loading}
            />
          </div>
          <div className="filtro-item">
            <label>
              <FaCalendarAlt /> Año
            </label>
            <YearDropdown
              value={anioSeleccionado}
              onChange={setAnioSeleccionado}
              options={Array.from({ length: 6 }).map((_, i) => {
                const y = String(now.getFullYear() - i);
                return { value: y, label: y };
              })}
              disabled={loading}
            />
          </div>

          <div className="filtro-item filtro-colaborador">
            <label>
              <FaUserTie /> Colaborador
            </label>
            <ColaboradorDropdown
              value={colaboradorSeleccionado}
              onChange={setColaboradorSeleccionado}
              options={[{ value: '', label: 'Seleccionar colaborador...' }, ...colaboradores.map(col => ({ value: col.id, label: col.nombre }))]}
              disabled={loading}
            />
          </div>

          
        </div>

        <div className="filtros-actions">
          <button 
            className="btn-generar" 
            onClick={handleGenerarReporte}
            disabled={loading}
          >
            <FaSearch /> {loading ? 'Generando...' : 'Generar Reporte'}
          </button>
          {reporteGenerado && (
            <button className="btn-limpiar" onClick={handleLimpiar}>
              Limpiar Filtros
            </button>
          )}
        </div>
      </div>

      {reporteGenerado && !loading && (
        <div className="kpi-section">
          <div className="kpi-grid">
            <div className="kpi-card">
              <div className="kpi-label">Total a pagar</div>
              <div className="kpi-value">{formatMonto(totalLiquidoCalc)}</div>
              <div className="kpi-label">Líquido estimado</div>
            </div>
            <div className="kpi-card">
              <div className="kpi-label">Tareas aprobadas</div>
              <div className="kpi-value">{totalTareasAprobadas}</div>
              <div className="kpi-label">Incluye filtros actuales</div>
            </div>
            <div className="kpi-card">
              <div className="kpi-label">Horas trabajadas</div>
              <div className="kpi-value">{totalHoras}</div>
              <div className="kpi-label">Estimadas a 8 h/día</div>
            </div>
            <div className="kpi-card">
              <div className="kpi-label">Pagado vs Pendiente</div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr auto', gap: '.5rem', alignItems: 'center' }}>
                <div className="hbar-chart">
                  <div className="hbar-item">
                    <span className="hbar-label">Pagado</span>
                    <div className="hbar-bar" style={{ width: '100%' }} />
                    <span className="hbar-value">{formatMonto(montoPagadoCalc)}</span>
                  </div>
                  <div className="hbar-item">
                    <span className="hbar-label">Pendiente</span>
                    <div className="hbar-bar" style={{ width: '100%', background: 'linear-gradient(90deg,#f59e0b,#d97706)' }} />
                    <span className="hbar-value">{formatMonto(montoPendienteCalc)}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Loading */}
      {loading && (
        <div className="loading-reporte">
          <div className="spinner"></div>
          <p>Consolidando tareas y calculando montos...</p>
        </div>
      )}

      {/* Reporte Generado */}
      {reporteGenerado && !loading && (
        <div className="reporte-resultado">
          <div className="reporte-resultado-header">
            <div>
              <h2>Reporte Generado</h2>
              <p>Período: {formatMonthYear(mesSeleccionado, anioSeleccionado)}</p>
            </div>
          <div className="reporte-acciones" style={{ display: 'flex', gap: '0.75rem', alignItems: 'center', flexWrap: 'wrap' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', border: '2px solid #e2e8f0', borderRadius: '10px', padding: '0.4rem 0.6rem', background: '#fff' }}>
              <FaSearch style={{ color: '#8b5cf6' }} />
              <input
                value={busqueda}
                onChange={(e) => setBusqueda(e.target.value)}
                placeholder="Buscar por proyecto o tarea"
                style={{ border: 'none', outline: 'none', fontSize: '0.95rem', color: '#0f172a', width: '220px' }}
              />
            </div>
            <button className="btn-exportar" onClick={handleExportarPDF}>Exportar PDF</button>
            <button className="btn-exportar" onClick={handleExportarExcel}>Exportar Excel</button>
            <button className="btn-exportar" onClick={handleEnviarPDFCorreo}>Enviar por correo</button>
          </div>
          </div>

          {datosReporte.map((mes, idx) => (
            <div key={idx} className="colaborador-reporte">
              <div className="colaborador-header">
                <h3>
                  {mes.nombre_mes} {mes.anio}
                </h3>
                <div className="header-right">
                  <span className="total-colaborador">Total tareas: {mes.total_mes}</span>
                  <div className="acciones-mes">
                    <button className="btn-exportar" onClick={() => handleExportarPDFMes(mes)}>
                      Exportar PDF
                    </button>
                    {(() => {
                      const key = `${mes.anio}-${mesesCatalog.find(mm => mm.label === mes.nombre_mes)?.value || String(mes.mes || '').padStart(2,'0') || '01'}`;
                      const enviado = !!enviosCorreo[key];
                      return (
                        <button className={`btn-exportar ${enviado ? 'enviado' : ''}`} disabled={enviado} onClick={() => handleEnviarPDFCorreoMes(mes)}>
                          {enviado ? 'Enviado' : 'Enviar por correo'}
                        </button>
                      );
                    })()}
                    {(() => {
                      const key = `${mes.anio}-${mesesCatalog.find(mm => mm.label === mes.nombre_mes)?.value || String(mes.mes || '').padStart(2,'0') || '01'}`;
                      const enviado = !!envios[key];
                      return (
                        <button className={`btn-enviar ${enviado ? 'enviado' : ''}`} disabled={enviado} onClick={() => handleEnviarMesColaborador(mes)}>
                          {enviado ? 'Enviado' : 'Enviar a colaborador'}
                        </button>
                      );
                    })()}
                  </div>
                </div>
              </div>
              <div className="tabla-tareas-container">
                <table className="tabla-tareas">
                  <thead>
                    <tr>
                      <th>Colaborador</th>
                      <th>Tarea</th>
                      <th>Proyecto</th>
                      <th>Etapa</th>
                      <th className="col-fecha">Fecha límite</th>
                      <th className="col-fecha">Fecha aprobada</th>
                      <th className="col-duracion">Duración (días)</th>
                      <th className="col-horas">Horas diarias estimadas</th>
                      <th className="col-tarifa">Tarifa</th>
                      <th className="col-total">Total a pagar</th>
                    </tr>
                  </thead>
                  <tbody>
                    {mes.tareas.filter(matchesSearch).map((t, tidx) => (
                      <tr key={tidx}>
                        <td className="tarea-nombre">{String(t.colaborador?.nombre || '').toLowerCase().split(' ').filter(Boolean).map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ')}</td>
                        <td className="tarea-nombre">{t.nombre_tarea}</td>
                        <td className="tarea-nombre">{String(t.proyecto?.nombre_proyecto || '').toLowerCase().split(' ').filter(Boolean).map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ')}</td>
                        <td className="tarea-nombre">{String(t.etapa?.nombre || '').toLowerCase().split(' ').filter(Boolean).map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ')}</td>
                        <td className="tarea-horas">{fechaLimiteInicial(t)}</td>
                        <td className="tarea-horas">{t.fecha_aprobada}</td>
                        <td className="tarea-duration">{durationForTask(t)}</td>
                        <td className="tarea-horas-diarias">8 Hrs.</td>
                        <td className="tarea-tarifa">{formatMonto(tarifaPorUsuario[t.colaborador?.id_usuario || t.id_usuario_asignado])}</td>
                        <td className="tarea-total">
                          {(() => {
                            const monto = tarifaPorUsuario[t.colaborador?.id_usuario || t.id_usuario_asignado];
                            const dias = durationForTask(t);
                            const total = (monto != null) ? dias * 8 * Number(monto) : null;
                            return total != null ? formatMonto(total) : '-';
                          })()}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                  {(() => {
                    const mesTotal = (mes.tareas || []).filter(matchesSearch).reduce((acc, t) => {
                      const monto = tarifaPorUsuario[t.colaborador?.id_usuario || t.id_usuario_asignado] ?? null;
                      const dias = durationForTask(t);
                      const total = (monto != null) ? dias * 8 * Number(monto) : 0;
                      return acc + total;
                    }, 0);
                    return (
                      <tfoot>
                        <tr className="fila-total">
                          <td colSpan="9" style={{ textAlign: 'right' }}>
                            <span className="monto-base">Monto bruto:</span>
                          </td>
                          <td style={{ textAlign: 'right' }}>
                            <span className="monto-total">{formatMonto(mesTotal)}</span>
                          </td>
                        </tr>
                        <tr className="fila-total">
                          <td colSpan="9" style={{ textAlign: 'right' }}>
                            <span className="monto-base">Retención 14.5%:</span>
                          </td>
                          <td style={{ textAlign: 'right' }}>
                            <span className="monto-total">{formatMonto(Math.round(mesTotal * 0.145))}</span>
                          </td>
                        </tr>
                        <tr className="fila-total">
                          <td colSpan="9" style={{ textAlign: 'right' }}>
                            <span className="monto-base">Monto líquido pagar BH:</span>
                          </td>
                          <td style={{ textAlign: 'right' }}>
                            <span className="monto-total">{formatMonto(Math.max(0, mesTotal - Math.round(mesTotal * 0.145)))}</span>
                          </td>
                        </tr>
                      </tfoot>
                    );
                  })()}
                </table>
              </div>
            </div>
          ))}

          

        </div>
      )}

      {/* Sección Historial de Informes de Pago Emitidos */}
      <div className="historial-pago-section" style={{ marginTop: '2.5rem', background: '#ffffff', borderRadius: '16px', padding: '2rem', border: '2px solid #f1f5f9', boxShadow: '0 4px 16px rgba(0,0,0,0.06)' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1.5rem', flexWrap: 'wrap', gap: '1rem' }}>
          <div>
            <h2 style={{ fontSize: '1.25rem', fontWeight: 700, color: '#0f172a', margin: '0 0 0.25rem 0', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <FaFileInvoiceDollar style={{ color: '#8b5cf6' }} />
              Historial de Informes y Comprobantes de Pago
            </h2>
            <p style={{ fontSize: '0.875rem', color: '#64748b', margin: 0 }}>
              Registro consolidado de liquidaciones emitidas y estado de transferencias
            </p>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '10px', padding: '0.5rem 0.8rem', minWidth: '260px' }}>
            <FaSearch style={{ color: '#94a3b8', fontSize: '0.875rem' }} />
            <input
              type="text"
              value={historialBusqueda}
              onChange={(e) => setHistorialBusqueda(e.target.value)}
              placeholder="Buscar por colaborador o proyecto..."
              style={{ border: 'none', background: 'transparent', outline: 'none', fontSize: '0.875rem', color: '#0f172a', width: '100%' }}
            />
          </div>
        </div>

        {/* Resumen Métrico del Historial */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem', marginBottom: '1.5rem' }}>
          <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '12px', padding: '1rem' }}>
            <span style={{ fontSize: '0.75rem', fontWeight: 600, color: '#64748b', textTransform: 'uppercase' }}>Total Pagado (Líquido)</span>
            <p style={{ fontSize: '1.4rem', fontWeight: 800, color: '#10b981', margin: '0.25rem 0 0 0' }}>
              {formatMonto(historialPagos.filter(p => String(p.estado || '').toUpperCase() === 'PAGADO').reduce((s, p) => s + Math.round(Number(p.monto || p.monto_bruto || 0) * 0.855), 0))}
            </p>
          </div>
          <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '12px', padding: '1rem' }}>
            <span style={{ fontSize: '0.75rem', fontWeight: 600, color: '#64748b', textTransform: 'uppercase' }}>Retención 14.5% Acumulada</span>
            <p style={{ fontSize: '1.4rem', fontWeight: 800, color: '#f59e0b', margin: '0.25rem 0 0 0' }}>
              {formatMonto(historialPagos.reduce((s, p) => s + Math.round(Number(p.monto || p.monto_bruto || 0) * 0.145), 0))}
            </p>
          </div>
          <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '12px', padding: '1rem' }}>
            <span style={{ fontSize: '0.75rem', fontWeight: 600, color: '#64748b', textTransform: 'uppercase' }}>Pagos Pendientes</span>
            <p style={{ fontSize: '1.4rem', fontWeight: 800, color: '#ef4444', margin: '0.25rem 0 0 0' }}>
              {formatMonto(historialPagos.filter(p => String(p.estado || '').toUpperCase() === 'PENDIENTE').reduce((s, p) => s + Math.round(Number(p.monto || p.monto_bruto || 0) * 0.855), 0))}
            </p>
          </div>
          <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '12px', padding: '1rem' }}>
            <span style={{ fontSize: '0.75rem', fontWeight: 600, color: '#64748b', textTransform: 'uppercase' }}>Comprobantes Registrados</span>
            <p style={{ fontSize: '1.4rem', fontWeight: 800, color: '#6366f1', margin: '0.25rem 0 0 0' }}>
              {historialPagos.length}
            </p>
          </div>
        </div>

        {/* Tabla de Historial */}
        <div style={{ overflowX: 'auto' }}>
          <table className="tabla-tareas" style={{ width: '100%' }}>
            <thead>
              <tr>
                <th>N° Comprobante</th>
                <th>Colaborador</th>
                <th>Proyecto</th>
                <th>Período</th>
                <th style={{ textAlign: 'right' }}>Monto Bruto</th>
                <th style={{ textAlign: 'right' }}>Retención 14.5%</th>
                <th style={{ textAlign: 'right' }}>Monto Líquido</th>
                <th style={{ textAlign: 'center' }}>Estado</th>
                <th style={{ textAlign: 'center' }}>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {historialLoading ? (
                <tr>
                  <td colSpan={9} style={{ textAlign: 'center', padding: '2rem', color: '#64748b' }}>
                    Cargando historial de pagos...
                  </td>
                </tr>
              ) : historialPagos
                .filter(p => {
                  const s = historialBusqueda.toLowerCase().trim();
                  if (!s) return true;
                  const col = typeof p.colaborador === 'object' ? p.colaborador.nombre : p.colaborador;
                  return String(col || '').toLowerCase().includes(s) || String(p.proyecto || '').toLowerCase().includes(s) || String(p.periodo || '').toLowerCase().includes(s);
                })
                .map((p, idx) => {
                  const colNombre = typeof p.colaborador === 'object' ? (p.colaborador.nombre || 'Colaborador') : (p.colaborador || 'Colaborador');
                  const bruto = Number(p.monto || p.monto_bruto || 0);
                  const ret = Math.round(bruto * 0.145);
                  const liq = Math.max(0, bruto - ret);
                  const est = String(p.estado || '').toUpperCase();
                  return (
                    <tr key={p.id || p.id_pago || idx}>
                      <td style={{ fontWeight: 600, color: '#6366f1' }}>#PAGO-00{p.id || p.id_pago || (idx + 1)}</td>
                      <td style={{ fontWeight: 600, color: '#0f172a' }}>{colNombre}</td>
                      <td>{p.proyecto || 'General'}</td>
                      <td>{p.periodo || 'Febrero 2026'}</td>
                      <td style={{ textAlign: 'right', fontWeight: 600 }}>{formatMonto(bruto)}</td>
                      <td style={{ textAlign: 'right', color: '#f59e0b', fontWeight: 600 }}>{formatMonto(ret)}</td>
                      <td style={{ textAlign: 'right', color: '#10b981', fontWeight: 700 }}>{formatMonto(liq)}</td>
                      <td style={{ textAlign: 'center' }}>
                        <span style={{
                          display: 'inline-block',
                          padding: '0.25rem 0.75rem',
                          borderRadius: '9999px',
                          fontSize: '0.75rem',
                          fontWeight: 700,
                          backgroundColor: est === 'PAGADO' ? '#d1fae5' : '#fef3c7',
                          color: est === 'PAGADO' ? '#047857' : '#b45309'
                        }}>
                          {est === 'PAGADO' ? 'Pagado' : 'Pendiente'}
                        </span>
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'center' }}>
                          <button
                            onClick={() => handleExportarComprobanteHistorial(p)}
                            style={{ padding: '0.35rem 0.65rem', background: '#6366f1', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '0.75rem', fontWeight: 600, cursor: 'pointer' }}
                          >
                            Descargar PDF
                          </button>
                          {est === 'PENDIENTE' && (
                            <button
                              onClick={() => handleMarcarPagadoHistorial(p.id || p.id_pago)}
                              style={{ padding: '0.35rem 0.65rem', background: '#10b981', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '0.75rem', fontWeight: 600, cursor: 'pointer' }}
                            >
                              Marcar Pagado
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              {!historialLoading && historialPagos.length === 0 && (
                <tr>
                  <td colSpan={9} style={{ textAlign: 'center', padding: '2rem', color: '#64748b' }}>
                    No hay informes de pago en el historial
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default ReportesPago;
